export default __webpack_public_path__ + "static/media/modal-img.2b725bd2.png";